@if (field.sequentialView && isLanding) {
  <div class="common-text-input__container-field-sequential">
    <field-sequential-header [field]="field"></field-sequential-header>
    <label class="common-text-input__block-field-input-sequential"
      [ngClass]="{'common-text-input__block-field-input-sequential--error': field.error }"
      [attr.disabled]="field.noEditable?true:null"
      [for]="'field-item-numb-' + field.id">
      <p-inputNumber class="common-text-input__container-input"
        styleClass="common-text-input__input-number-sequential"
        [inputId]="'field-item-numb-' + field.id"
        mode="decimal"
        [min]="fieldTypeNumber.minValue"
        [maxlength]="field.maxLength?field.maxLength:'524288'"
        [maxFractionDigits]="fieldTypeNumber.decimals"
        [useGrouping]="!field.noUseSeparators"
        [disabled]="field.noEditable"
        [placeholder]="field.noEditable?'':((field.fieldTypeId === 'money'?'common.enter-value':'common.enter-number') | afTranslate)"
        [(ngModel)]="fieldTypeNumber.inputNumber"
        (onBlur)="changeInField()"></p-inputNumber>
    </label>
    @if (field.error) {
      <div class="common-text-input__mandatory-tag">
        @if(field.blocker){
          <i class="lf-icon-warning common-icon__error-md"></i>
        }
        @if (field.errorText) {
          <span>{{field.errorText}}</span>
        }@else if(fieldTypeNumber.inputNumber && field.errorInForm){
          <span [afTranslate]="'field-type-number.error-range-value'">El valor no está dentro del rango permitido</span>
        }@else{
          <span [afTranslate]="field.blocker?'common.field-mandatory-blocking':'common.field-mandatory'">Campo obligatorio</span>
        }
      </div>
    }
  </div>
}@else {
  <div class="common-text-input__container"
    [id]="field.id">
    <div class="common-text-input__container-box"
      [ngClass]="{'common-text-input__container-box--error': field.error || field.errorInForm}"
      [attr.disabled]="field.noEditable?true:null">
      <div class="common-text-input__block-header">
        <label class="common-text-input__label"
          [for]="'field-item-numb-'+field.id">
          <span class="common-text-input__text-label">{{fieldTypeNumber.titleField}}</span>
          @if (field.required) {
            <span class="common-tag__mandatory-text-asterisk">*</span>
          }
          <div class="common-text-input__block-buttons">
            @if (field.description) {
              <tooltip-info [description]="field.description"
              [field]="field"></tooltip-info>
            }
            @if (field.references?.length) {
              <tooltip-law [references]="field.references"
              [field]="field"></tooltip-law>
            }
            @if (field.relatedInfo?.length) {
              <button class="common-button__icon-sm-noborder"
                pTooltip="{{'common.related-info'| afTranslate}}"
                tooltipPosition="top"
                (click)="openModalRelatedInfo(field.relatedInfo, $event)">
                <i class="lf-icon-search-text common-icon__md"></i>
              </button>
            }
            @if (field.inReport !== null && field.inReport !== undefined && !isLanding){
              <tooltip-in-report [inReport]="fieldTypeNumber.inReport"></tooltip-in-report>
            }
          </div>
        </label>
      </div>
      <div class="common-text-input__block-input"
        [ngClass]="{'common-text-input__block-input--with-value': (fieldTypeNumber.inputNumber || fieldTypeNumber.inputNumber === 0) && !field.noEditable}">
        <p-inputNumber class="common-text-input__container-input"
          styleClass="common-text-input__input-number"
          [inputId]="'field-item-numb-' + field.id"
          mode="decimal"
          [min]="fieldTypeNumber.minValue"
          [maxlength]="field.maxLength?field.maxLength:'524288'"
          [maxFractionDigits]="fieldTypeNumber.decimals"
          [useGrouping]="!field.noUseSeparators"
          [disabled]="field.noEditable"
          [placeholder]="field.noEditable?'':fieldTypeNumber.placeholder"
          [(ngModel)]="fieldTypeNumber.inputNumber"
          (onBlur)="changeInField()"></p-inputNumber>
        @if ((fieldTypeNumber.inputNumber || fieldTypeNumber.inputNumber === 0) && !field.noEditable) {
          <button class="common-text-input__icon-clean-input"
            (click)="resetNumber()">
            <i class="lf-icon-close-thick common-icon__sm"></i>
          </button>
        }
      </div>
    </div>
    @if(field.error || field.errorInForm){
      <div class="common-text-input__mandatory-tag">
        @if(field.blocker){
          <i class="lf-icon-warning common-icon__error-md"></i>
        }
        @if (field.errorText) {
          <span>{{field.errorText}}</span>
        }@else if(fieldTypeNumber.inputNumber && field.errorInForm){
          <span [afTranslate]="'field-type-number.error-range-value'">El valor no está dentro del rango permitido</span>
        }@else{
          <span [afTranslate]="field.blocker?'common.field-mandatory-blocking':'common.field-mandatory'">Campo obligatorio</span>
        }
      </div>
    }
  </div>
}
